import {Slide} from '@aboutyou/transitions';
import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';

type NotificationTypes = 'FAILURE' | 'SUCCESS';

interface NotificationProps {
  type: NotificationTypes;
  dataTestid?: string;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right';
  duration?: number;
  isShown: boolean;
}

export const Notification: FC<React.PropsWithChildren<NotificationProps>> = ({
  type,
  children,
  dataTestid = 'notification',
  className,
  direction = 'up',
  duration = 500,
  isShown,
}) => {
  return (
    <Slide mounted={isShown} direction={direction} duration={duration}>
      <StyledNotification
        data-testid={dataTestid}
        className={className}
        type={type}
      >
        {children}
      </StyledNotification>
    </Slide>
  );
};

const StyledNotification = styled.span<{type: NotificationTypes}>`
  background-color: ${({type}) => {
    switch (type) {
      case 'FAILURE':
        return COLORS.Red;
      case 'SUCCESS':
        return COLORS.Green;
      default:
        return COLORS.Grey4;
    }
  }};
  align-items: center;
  border-radius: 3px;
  color: ${COLORS.White};
  display: flex;
  font-weight: bold;
  flex-basis: 100%;
  justify-content: center;
  margin-top: 5px;
  padding: 4px 12px;
`;
